<template>
  <div class="product fs-16 pb-60 shopping-cart">
    <template v-if="dataList.length">
      <ul class="s-list mt-20">
        <li v-for="(o, i) in dataList" :key="i">
          <div class="a-pic"><img :src="o.img" v-if="o.img"/></div>
          <div class="li-cont">
            <div class="flex1">
              <div class="fs-24 bold">{{o.productName}}</div>
              <div class="mt-10">数量： {{o.productNum}}</div>
              <div class="mt-10" v-if="o.productAttribute.length">
                <span class="a-attribute" v-for="(a, j) in o.productAttribute" :key="j">
                  <span class="a-dot"></span><span>{{a.attributeName}}：{{a.attributeValue}}</span>
                </span>
              </div>
            </div>
            <div class="price text-r">
              <p class="fs-24 bold">RMB <span class="col-blue">{{o.price}}</span></p>
              <el-button type="text" @click="delProduct(i)">移除</el-button>
            </div>
          </div>
        </li>
      </ul>
      <div class="li-cont total-mol">
        <div class="flex1 fs-24 bold">总计</div>
        <div class="price text-r">
          <p class="fs-24 bold">RMB <span class="col-blue">{{total}}</span></p>
          <el-button type="primary" class="a-btn" @click="showPop">咨询</el-button>
        </div>
      </div>
    </template>
    <div class="empty-mol" v-else-if="isLoad">
      <template v-if="isSubmit">
        <div class="a-icon"><i class="el-icon-message ml-0"></i></div>
        <p class="fs-26 bold">您的咨询已提交成功，后期会有工作人员与您联系</p>
        <el-button type="primary" class="a-btn" @click="toShopping">继续购物</el-button>
      </template>
      <template v-else>
        <div class="a-icon"><i class="el-icon-shopping-cart-2"></i></div>
        <p class="fs-26 bold">您的购物车里没有商品</p>
        <el-button type="primary" class="a-btn" @click="toShopping">去购物</el-button>
      </template>
    </div>
    <el-dialog :visible.sync="showDialog" width="90%" class="zx-pop" title="咨询详情" center :close-on-click-modal="false">
      <el-form ref="form" label-position="top" :model="formData" :rules="rules">
        <el-form-item prop="customerName">
          <template slot="label">姓名<span class="col-red">(必填)</span></template>
          <el-input v-model="formData.customerName"></el-input>
        </el-form-item>
        <el-form-item prop="customerMobile">
          <template slot="label">手机号码<span class="col-red">(必填)</span></template>
          <el-input v-model="formData.customerMobile"></el-input>
        </el-form-item>
        <el-form-item prop="customerEmail">
          <template slot="label">电子邮箱<span class="col-red">(必填)</span></template>
          <el-input v-model="formData.customerEmail"></el-input>
        </el-form-item>
        <el-form-item></el-form-item>
        <el-form-item prop="customerCompanyName">
          <template slot="label">所在公司名称<span class="col-red">(必填)</span></template>
          <el-input v-model="formData.customerCompanyName"></el-input>
        </el-form-item>
        <el-form-item prop="customerAreaId">
          <template slot="label">公司所在地<span class="col-red">(必填)</span></template>
          <el-cascader
          v-model="formData.customerAreaId"
          :props="cascaderProps">
          </el-cascader>
        </el-form-item>
      </el-form>
      <p class="pt-20 pb-20 fs-24 bold col-blue text-c">当前商品总价格：{{total}}元</p>
      <div class="pt-20 pl-20">
        <p><span class="col-red">温馨提示：</span>请填写以上内容，后期会有工作人员与您联系或者您可主动联系工作人员</p>
        <p class="mt-10" v-if="basicInfo.displayPhone == 1">电话：{{basicInfo.phone}}</p>
        <p class="mt-10" v-if="basicInfo.displayCooperationPhone == 1">商务合作：{{basicInfo.cooperationPhone}}</p>
        <div class="mt-10">
          <span class="pt-10" style="vertical-align: top">商务微信：</span>
          <img :src="basicInfo.wxBusinessUrl" class="wx-img"/>
        </div>
      </div>
      <el-button type="primary" class="a-btn btn-2" @click="submite">确定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { getSession } from '@/utils/index'
export default {
  name: 'productCompare',
  data () {
    let getAreaListByParentId = this.API.product.getAreaListByParentId
    const valPhone = (rule, value, callback) => {
      if (!(/^1[34578]\d{9}$/.test(value))) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      isLoad: false,
      originalData: [],
      dataList: [],
      total: '0',
      showDialog: false,
      formData: {
        customerName: '',
        customerMobile: '',
        customerEmail: '',
        customerCompanyName: '',
        customerAreaId: ''
      },
      rules: {
        customerName: [
          { required: true, message: '请输入名字', trigger: 'blur' },
          { max: 20, message: '最多20个字', trigger: ['blur', 'change'] }
        ],
        customerMobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: valPhone, trigger: ['blur', 'change'] }
        ],
        customerEmail: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] },
          { max: 40, message: '最多40个字', trigger: ['blur', 'change'] }
        ],
        customerCompanyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { max: 50, message: '最多50个字', trigger: ['blur', 'change'] }
        ],
        customerAreaId: [
          { required: true, message: '请选择所在省/市', trigger: 'change' }
        ]
      },
      cascaderProps: {
        emitPath: false,
        lazy: true,
        lazyLoad (node, resolve) {
          let { level, value } = node
          value = value || 0
          getAreaListByParentId({
            parentId: value
          }).then((res) => {
            let data = res.data || []
            let _data = []
            data.map(o => {
              _data.push({
                value: o.areaId,
                label: o.areaName,
                leaf: level > 0 || [2706, 5166, 5615].includes(o.areaId)
              })
            })
            resolve(_data)
          })
        }
      },
      isSubmit: false,
      basicInfo: {}
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      let data = localStorage.getItem('prdt')
      data = data ? JSON.parse(data) : []
      this.originalData = data
      let total = 0
      let _data = []
      data.map(o => {
        o.price = Number((o.productPrice * o.productNum).toFixed(2))
        total += o.price
        _data.push(o)
      })
      this.total = total.toFixed(2)
      this.dataList = _data
      this.isLoad = true
    },
    delProduct (i) {
      this.dataList.splice(i, 1)
      this.originalData.splice(i, 1)
      let total = 0
      this.dataList.map(o => {
        total += o.price
      })
      this.total = total.toFixed(2)
      localStorage.setItem('prdt', JSON.stringify(this.originalData))
      this.$store.state.cartNum++
    },
    showPop () {
      this.basicInfo = getSession('basicInfo')
      this.showDialog = !this.showDialog
    },
    submite () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$loading()
          let orderItems = []
          this.originalData.map(o => {
            orderItems.push({
              itemType: o.itemType,
              productName: o.productName,
              productNum: o.productNum,
              productPrice: o.productPrice,
              productAttribute: JSON.stringify(o.productAttribute)
            })
          })
          this.API.product.addOrder({
            ...this.formData,
            orderItems
          }).then((res) => {
            this.dataList = []
            this.originalData = []
            localStorage.setItem('prdt', JSON.stringify(this.originalData))
            this.$store.state.cartNum++
            this.showDialog = false
            this.isSubmit = true
            this.$loading().close()
          })
        }
      })
    },
    toShopping () {
      this.$router.push({ name: 'productCenter' })
    }
  }
}
</script>
